const API_URL = window.location.origin;
export const API_REST_URL = `${API_URL}/api`;
